"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteNavMobileLinks = exports.HideOverflow = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const window_or_global_1 = __importDefault(require("window-or-global"));
const shared_1 = require("../../shared");
const atoms_1 = require("../atoms");
const CtaButtonMobile_1 = require("../cta/CtaButtonMobile");
const LocaleMobile_1 = require("../locale/LocaleMobile");
const LocaleMobileTray_1 = require("../locale/LocaleMobileTray");
const menu_1 = require("../menu");
const SearchMobile_1 = require("../search/SearchMobile");
const tray_1 = require("../tray");
const AccountMobile_1 = require("../user/AccountMobile");
const SignInMobileTray_1 = require("../user/SignInMobileTray");
const BottomMobile = styled_components_1.default.div `
	box-shadow: 0 -4px 15px -4px rgb(0 0 0 / 50%);
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;

	.landscape-btn {
		display: none;
		height: 32px;
		width: 100%;
		justify-content: center;
		align-items: center;

		@media only screen and (max-device-width: 960px) and (orientation: landscape) {
			display: flex;
		}
	}

	.bottom-mobile-content {
		&.landscapeBottomClosed {
			@media only screen and (max-device-width: 960px) and (orientation: landscape) {
				display: none;
			}
		}
	}

	.user-locale-options {
		position: relative;
		overflow: hidden;
		width: 100%;
		height: ${(p) => p.theme.navHeight}px;
		border-top: 1px solid ${(p) => p.theme.palette.border};

		> div {
			display: inline-block;
			text-align: center;

			&:first-child {
				border-right: 1px solid ${(p) => p.theme.palette.border};
			}

			&:last-child {
				border-right: none;
			}
		}
	}
`;
exports.HideOverflow = (0, styled_components_1.createGlobalStyle) `
    body {
        height: 100%;
        width: 100%;
        overflow: hidden;
        position: fixed;
    }
`;
const MobileTrayMenus = styled_components_1.default.div `
	max-height: ${(p) => `calc(100% - ${p.bottomMobileHeight}px)` || "100%"};
	overflow-y: auto;
`;
const SiteNavMobileLinks = (props) => {
    const { links = [], callToAction = {}, callToActionDropdown = {}, isLoggedIn, displayName, hideSignIn, hideCallToAction, hideSearch, hideLocale, accountLinks = {}, locale, localeOptions = [], ctaMobilePosition, onSearch, topOffset, burgerCallback, } = props;
    const menuId = "sitenav-mobile";
    const [landscapeBottomOpen, setLandscapeBottomOpen] = (0, react_1.useState)(false);
    const [bottomMobileHeight, setBottomMobileHeight] = (0, react_1.useState)(205);
    const { mobileMenuOpen, setMobileMenuOpen } = (0, shared_1.useMobileMenu)();
    const { setInnerMobileMenu } = (0, shared_1.useInnerMobileMenu)();
    const setMobileTray = (0, react_1.useCallback)((menuopen) => {
        //close the inner tray
        setInnerMobileMenu("");
        setMobileMenuOpen(menuopen);
        if (burgerCallback && typeof burgerCallback === "function") {
            burgerCallback(menuopen);
        }
    }, [burgerCallback]);
    const toggleMobileMenu = (0, shared_1.useToggleMenu)(mobileMenuOpen, setMobileTray, menuId);
    const bottomMobileRef = (0, react_1.useCallback)((node) => {
        if (node !== null) {
            const bottomHeight = node.getBoundingClientRect().height;
            setBottomMobileHeight(bottomHeight);
        }
    }, []);
    const toggleLandscapeTray = (0, react_1.useCallback)(() => {
        setLandscapeBottomOpen(!landscapeBottomOpen);
        //we want the new height after the re-render
        setTimeout(() => {
            const el = window_or_global_1.default.document.getElementById("bottomMobile");
            if (el) {
                setBottomMobileHeight(el.getBoundingClientRect().height);
            }
        }, 50);
    }, [landscapeBottomOpen, setLandscapeBottomOpen]);
    const isCtaTopPosition = ctaMobilePosition === "topNav";
    const isBurgerAccentColor = !mobileMenuOpen && !isCtaTopPosition;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        mobileMenuOpen ? react_1.default.createElement(exports.HideOverflow, null) : "",
        isCtaTopPosition ? (react_1.default.createElement(CtaButtonMobile_1.CtaButtonMobile, Object.assign({}, callToAction, { hide: hideCallToAction, position: ctaMobilePosition, callToActionDropdown: callToActionDropdown }))) : (""),
        react_1.default.createElement(menu_1.Menu, { role: "menu", static: true },
            react_1.default.createElement(menu_1.DropdownSummary, { menuId: "mobile-burger", openMenu: toggleMobileMenu, onKeyUp: toggleMobileMenu, accentColor: isBurgerAccentColor },
                react_1.default.createElement(atoms_1.Burger, { menuOpen: mobileMenuOpen, accentColor: isBurgerAccentColor })),
            react_1.default.createElement(tray_1.LinksTrayWrap, { menuOpen: mobileMenuOpen, mobile: true, topOffset: topOffset },
                react_1.default.createElement(tray_1.LinksTray, { menuOpen: mobileMenuOpen, mobile: true },
                    react_1.default.createElement(MobileTrayMenus, { bottomMobileHeight: bottomMobileHeight }, links.map((link, i) => {
                        const key = link.key || `mobile-try-menu-${i}`;
                        if (link.isBarDivider)
                            return null;
                        return (react_1.default.createElement(tray_1.MobileTrayMenu, { key: `tray-item-${key}`, parentMenuOpen: mobileMenuOpen, link: link, trayId: key, locale: locale, topOffset: topOffset }));
                    })),
                    react_1.default.createElement(LocaleMobileTray_1.LocaleMobileTray, { locale: locale, localeOptions: localeOptions, hide: hideLocale }),
                    react_1.default.createElement(SignInMobileTray_1.SignInMobileTray, { isLoggedIn: isLoggedIn, accountLinks: accountLinks, hide: hideSignIn, locale: locale }),
                    react_1.default.createElement(BottomMobile, { id: "bottomMobile", ref: bottomMobileRef },
                        react_1.default.createElement("div", { role: "presentation", className: "landscape-btn", onClick: toggleLandscapeTray },
                            react_1.default.createElement(atoms_1.ArrowIcon, { face: landscapeBottomOpen ? "down" : "up" })),
                        react_1.default.createElement("div", { className: (0, classnames_1.default)("bottom-mobile-content", {
                                landscapeBottomClosed: !landscapeBottomOpen,
                            }) },
                            react_1.default.createElement(SearchMobile_1.SearchMobile, { hide: hideSearch, onSearch: onSearch }),
                            react_1.default.createElement("div", { className: "user-locale-options" },
                                react_1.default.createElement(AccountMobile_1.AccountMobile, { isLoggedIn: isLoggedIn, displayName: displayName, accountLinks: accountLinks, hide: hideSignIn, hideLocale: hideLocale }),
                                react_1.default.createElement(LocaleMobile_1.LocaleMobile, { locale: locale, localeOptions: localeOptions, hide: hideLocale, hideSignIn: hideSignIn })),
                            !isCtaTopPosition ? (react_1.default.createElement(CtaButtonMobile_1.CtaButtonMobile, Object.assign({}, callToAction, { hide: hideCallToAction, callToActionDropdown: callToActionDropdown }))) : (""))))),
            react_1.default.createElement(tray_1.MobileTrayOverlay, { topOffset: topOffset }))));
};
exports.SiteNavMobileLinks = SiteNavMobileLinks;
//# sourceMappingURL=SiteNavMobileLinks.js.map